import { ConversionTracker } from 'api-clients/monolith/models/ConversionTracker';

// Perengo Tracking Script
export const perengoScript = (tracker: ConversionTracker) => {
  return `<script type="text/javascript">
  (function(c,a,p,t,u,r,e){
      if(!c[u]){
        c.GlobalSnowplowNamespace = c.GlobalSnowplowNamespace||[];
        c.GlobalSnowplowNamespace.push(u);
        c[u] = function(){(c[u].q = c[u].q||[]).push(arguments)};
        c[u].q = c[u].q||[];
        r = a.createElement(p);
        e = a.getElementsByTagName(p)[0];
        r.async = 1;
        r.src = t;
        e.parentNode.insertBefore(r,e)
      }
    }
    (window,document,"script","//d1fc8wv8zag5ca.cloudfront.net/2.6.1/sp.js","analytics_perengo")
  );
  window.analytics_perengo('newTracker', "${tracker.tracking_pixel}-tracker", 'analytics.perengo.com', {appId: "${tracker.tracking_pixel}"});
  window.analytics_perengo('trackPageView');
  window.analytics_perengo('trackStructEvent','conversion','application-complete','courier','1','10.00');
</script>`;
};
